import { render, staticRenderFns } from "./_mainProjectId.vue?vue&type=template&id=4ee8315e"
import script from "./_mainProjectId.vue?vue&type=script&lang=js"
export * from "./_mainProjectId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports